
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { HospitalizationRegime, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class HospitalizationRegimeEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    hospitalizationRegime: HospitalizationRegime;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getHospitalizationRegime()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getHospitalizationRegime(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.hospitalizationRegime = data;
                this.onDataChanged.next(this.hospitalizationRegime);
                resolve(this.hospitalizationRegime);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('hospitalizationRegime/' + this.routeParams.id).subscribe((res: HospitalizationRegime ) => {
                    this.hospitalizationRegime = res;
                    this.onDataChanged.next(this.hospitalizationRegime);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(hospitalizationRegime): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('hospitalizationRegime/', hospitalizationRegime).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(hospitalizationRegime): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('hospitalizationRegime/', hospitalizationRegime).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(hospitalizationRegime): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('hospitalizationRegime/' + hospitalizationRegime.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): HospitalizationRegime {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
